export default "__VITE_ASSET__DUIyR3fZ__"